<template>
  <transition name="toast">
    <div v-if="toast.show" class="toast-wrapper" :class="toast.type">
      <div class="toast-content">
        <div class="toast-icon">
          <svg v-if="toast.type === 'success'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"/>
          </svg>
        </div>
        <span class="toast-message">{{ toast.message }}</span>
      </div>
      <button class="toast-close" @click="closeToast">×</button>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Toast",
  computed: {
    toast() {
      return this.$store.state.toast;
    }
  },
  watch: {
    'toast.show'(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.closeToast();
        }, 3000);
      }
    }
  },
  methods: {
    closeToast() {
      this.$store.commit("hideToast");
    }
  }
};
</script>

<style scoped>
.toast-wrapper {
  position: fixed;
  top: 80px; /* Below typical header height */
  right: 20px;
  min-width: 250px;
  background: white;
  border-radius: 8px;
  padding: 12px 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 9999;
  border-left: 5px solid #27ae60;
}

.toast-wrapper.success { border-left-color: #27ae60; }
.toast-wrapper.error { border-left-color: #dc3545; }
.toast-wrapper.info { border-left-color: #3182ce; }

.toast-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.toast-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.success .toast-icon { color: #27ae60; }
.error .toast-icon { color: #dc3545; }
.info .toast-icon { color: #3182ce; }

.toast-message {
  font-size: 14px;
  font-weight: 600;
  color: #2d3748;
}

.toast-close {
  background: none;
  border: none;
  font-size: 20px;
  color: #a0aec0;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  margin-left: 10px;
}

.toast-close:hover {
  color: #4a5568;
}

/* Transitions */
.toast-enter-active,
.toast-leave-active {
  transition: all 0.4s ease;
}

.toast-enter-from {
  transform: translateX(100px);
  opacity: 0;
}

.toast-leave-to {
  transform: translateX(100px);
  opacity: 0;
}
</style>
